import { EntityBadge } from '@abb-procure/common';
import { EntityIdAliasPrefixes } from '@abb-procure/constants';
import { UserState } from '@abb-procure/data';
import { TemplateFinderDialogService } from '@abb-procure/template-finder';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  viewChild,
} from '@angular/core';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';

@Component({
  selector: 'procure-create-menu',
  templateUrl: './create-menu.component.html',
  imports: [MatMenu, MatMenuItem, EntityBadge, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateMenu {
  readonly menu = viewChild.required(MatMenu);

  protected readonly permissions = computed(
    () => this.userState.current()?.permissions,
  );

  protected readonly EntityIdAliasPrefixes = EntityIdAliasPrefixes;

  private readonly userState = inject(UserState);
  private readonly router = inject(Router);

  private readonly templateFinderDialogService = inject(
    TemplateFinderDialogService,
  );

  protected addProject(): void {
    this.router
      .navigate(['/'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/PROJ/add']));
  }

  protected addRequestForRfq(): void {
    this.router
      .navigate(['/'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/RFRFQ/add']));
  }

  protected showTemplateFinder(): void {
    this.templateFinderDialogService.openTemplateFinderDialog();
  }
}
